import { createTheme } from "@mui/material/styles";

import { palette } from "./constants/palette";
import { shadows } from "./constants/shadows";
import { components } from "./constants/components";
import { typography } from "./constants/typography";
import { shape } from "./constants/shape";

export const theme = createTheme({
  palette,
  shadows,
  components,
  typography,
  shape,
});
